export default class Bg {
    constructor() {
        this.$modalTrigger = $('.cd-modal-trigger');
        this.$transitionLayer = $('.cd-transition-layer');
        this.$transitionBackground = this.$transitionLayer.children();
        this.$modalWindow = $('.cd-modal');

        this.resize = false;
        this.init();
    }

    init() {
        this.setLayerDimensions();

        const that = this;

        $(window).on('resize', function () {
            if (!that.resize) {
                that.resize = true;
                !window.requestAnimationFrame ? setTimeout(that.setLayerDimensions, 300) : window.requestAnimationFrame(that.setLayerDimensions);
            }
        });
    }

    openModalWindow() {
        const that = this;

        this.$transitionLayer.addClass('visible opening');
        setTimeout(function () {
            that.$modalWindow.addClass('visible');
        }, 600);
    }

    closeModalWindow() {
        const that = this;

        this.$transitionLayer.addClass('closing');
        this.$modalWindow.removeClass('visible');
        this.$transitionBackground.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
            that.$transitionLayer.removeClass('closing opening visible');
            that.$transitionBackground.off('webkitAnimationEnd oanimationend msAnimationEnd animationend');
        });

        // 途中でスクロールした時用
        setTimeout(function () {
            that.$modalWindow.removeClass('visible');
        }, 600);
    }

    setLayerDimensions() {
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        const frameProportion = 1.78; //png frame aspect ratio
        const frames = 25; //number of png frames

        const $transitionLayer = $('.cd-transition-layer');
        const $transitionBackground = $transitionLayer.children();

        let layerHeight = 0;
        let layerWidth = 0;
        let resize = false;

        if (windowWidth / windowHeight > frameProportion) {
            layerWidth = windowWidth;
            layerHeight = layerWidth / frameProportion;
        } else {
            layerHeight = windowHeight * 1.2;
            layerWidth = layerHeight * frameProportion;
        }

        $transitionBackground.css({
            width: layerWidth * frames + 'px',
            height: layerHeight + 'px',
        });

        resize = false;
    }
}
